import blog1 from '../img/blogs/1.webp';
import blog2 from '../img/blogs/2.webp';
import blog3 from '../img/blogs/3.webp';
import blog4 from '../img/blogs/4.webp';
import blog5 from '../img/blogs/5.webp';
import blog6 from '../img/blogs/6.webp';
import { ProductionHooksPost } from '../Components/Blog/Blogs/ProductionHooksPost';
import { ContextToZustandPost } from '../Components/Blog/Blogs/ContextToZustandPost';
import { DDDNestEventsPost } from '../Components/Blog/Blogs/DDDNestEventsPost';
import { RSCSuspensePost } from '../Components/Blog/Blogs/RSCSuspensePost';
import { AwsRdsReadReplicasPost } from '../Components/Blog/Blogs/AwsRdsReadReplicasPost';
import { ModuleFederationNXPost } from '../Components/Blog/Blogs/ModuleFederationNXPost';

export const blogData = [
  {
    id: 1,
    image: blog1,
    title: '3 Production-Ready Custom Hooks',
    alt: '3 Production-Ready Custom Hooks',
    content: <ProductionHooksPost />,
  },
  {
    id: 2,
    image: blog2,
    title: 'Context API → Zustand in 5 Steps',
    alt: 'Context API → Zustand in 5 Steps',
    content: <ContextToZustandPost />,
  },
  {
    id: 3,
    image: blog3,
    title: 'DDD with NestJS: Aggregates & Domain Events',
    alt: 'DDD with NestJS: Aggregates & Domain Events',
    content: <DDDNestEventsPost />,
  },
  {
    id: 4,
    image: blog4,
    title: 'React Server Components + Suspense',
    alt: 'React Server Components + Suspense',
    content: <RSCSuspensePost />,
  },
  {
    id: 5,
    image: blog5,
    title: 'Micro-frontends with Module Federation + NX',
    alt: 'Micro-frontends with Module Federation + NX',
    content: <AwsRdsReadReplicasPost />,
  },
  {
    id: 6,
    image: blog6,
    title: 'Scaling PostgreSQL on AWS RDS with Read Replicas',
    alt: 'Scaling PostgreSQL on AWS RDS with Read Replicas',
    content: <ModuleFederationNXPost />,
  },
];
